import { Currency } from "common/values/currency/currency";

export interface InsuranceInfoJSON {
  insuredAmount: number;
  currency?: string;
}

export default class InsuranceInfo {
  insuredAmount: number;
  currency?: Currency;

  constructor(amount: number, currency?: Currency) {
    this.insuredAmount = amount;
    this.currency = currency ?? Currency.USD;
  }

  public static fromJSON(json: InsuranceInfoJSON) {
    if (!json) return;
    const { insuredAmount, currency } = json;
    return new InsuranceInfo(
      insuredAmount,
      Currency[currency as keyof typeof Currency]
    );
  }

  public toJSON(): InsuranceInfoJSON {
    return {
      insuredAmount: this.insuredAmount,
      currency: this.currency
    };
  }
}
